"use strict";import{tag as l}from"../custom-tag.js";export function briefcaseIcon({height:a=16,width:r=16,hidden:e=!1,title:t="Briefcase"}={}){return l`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${r}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${e?"true":"false"}"
      role="img"
      aria-label="${t}"
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        stroke-width=".25"
        d="M20.4 6.996h-3.675V5.4a.826.826 0 0 0-.825-.825H8.1a.826.826 0 0 0-.825.825v1.596H3.6a.826.826 0 0 0-.825.825V18.6a.826.826 0 0 0 .825.825h16.8a.826.826 0 0 0 .825-.825V7.821a.826.826 0 0 0-.825-.825ZM7.725 5.4a.375.375 0 0 1 .375-.375h7.8a.375.375 0 0 1 .375.375v1.596h-8.55zm13.05 13.2a.375.375 0 0 1-.375.375H3.6a.375.375 0 0 1-.375-.375v-6.482c.129.07.273.106.42.107h7.454v.974a.225.225 0 0 0 .225.225H12.7a.225.225 0 0 0 .225-.225v-1.014l7.43.04c.147 0 .29-.037.42-.107zm-9.226-5.626v-2.03h.926v2.03zm9.226-1.574a.4.4 0 0 1-.418.375l-7.432-.04V10.72a.225.225 0 0 0-.225-.225h-1.376a.225.225 0 0 0-.225.225v1.056H3.644a.4.4 0 0 1-.42-.375v-3.58A.37.37 0 0 1 3.3 7.61a.43.43 0 0 1 .255-.153l.01-.002.08-.008h16.711q.04 0 .08.008l.01.002a.43.43 0 0 1 .265.167.36.36 0 0 1 .065.198z"
      />
    </svg>
  `}
//# sourceMappingURL=briefcase.js.map
